import { referralAPI } from './api';

const KEY = 'pendingReferral';

// Capture ?ref=CODE from the URL and remember it until the user signs up.
export function captureReferral() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) localStorage.setItem(KEY, ref.trim().toUpperCase());
  } catch { /* ignore */ }
}

// Redeem a stored referral code after a new user signs up. Best-effort; never blocks signup.
export async function redeemPendingReferral() {
  const code = localStorage.getItem(KEY);
  if (!code) return null;
  try {
    const res = await referralAPI.redeem(code);
    localStorage.removeItem(KEY);
    return res.data;
  } catch {
    localStorage.removeItem(KEY);
    return null;
  }
}
